import React, { useState } from "react";

import { InfoWindow, Marker, OverlayView } from "@react-google-maps/api";
import employeeIcon from "../../img/user.png";
import { height } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import "./Dashboard.css";


const UserWithLabel = ({ user, isEmployee, isClient, isDashboard }) => {
  console.log(user)
  const [selectId, setSelectId] = useState(null);
  const [open, setOpen] = useState(true);
  // const handleActiveMarker = (marker) => {
  //   if (marker === activeMarker) {
  //     return;
  //   }
  //   setActiveMarker(marker);
  // };
  const onLoadInfo = (infoWindow) => {
    //console.log(infoWindow, "infoWindow");
  };

  const DefaultUserIcon = {
    url: employeeIcon,
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 15),
    scaledSize: new window.google.maps.Size(30, 30),
  };
  const UserIcon = {
    url: user.image_url + "#custom_marker",
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 15),
    scaledSize: new window.google.maps.Size(30, 30),
    shape: { coords: [17, 17, 18], type: "circle" },
    optimized: false,
    title: "spot",
    // shape: { coords: [50, 50, 18], type: "circle" },
  };

  const openInfoWindow = (user) => {
    setSelectId(user.id);
    setOpen(true);
  };
  const closeInfoWindow = () => {
    setOpen(false);
  };

  const divStyle = {
    // content: '<div class="mylabel">The label</div>',
    // position: new window.google.maps.LatLng(-32.0, 149.0),
    // shadowStyle: 1,
    padding: "5px",
    textAlign: "center",
    // width:"100px",
    // height:"40px"
    // backgroundColor: 'rgb(57,57,57)',
    // borderRadius: 5,
    // arrowSize: 10,
    // borderWidth: 1,
    // borderColor: '#2c2c2c',
     disableAutoPan: false,
     hideCloseButton: false,
    // arrowPosition: 30,
    // backgroundClassName: 'transparent',
    // arrowStyle: 2
    // padding: 15
  };
  const onLoad = infoWindow => {
   // console.log('infoWindow: ', infoWindow)
  }

  return (
    <>
      <div id="infhobox" className="overlaps">
        <Marker
          position={{
            lat: user.latitude,
            lng: user.longitude,
          }}
          icon={
            isEmployee && user.image_url !== null
              ? UserIcon
              : isClient
              ? null
              : DefaultUserIcon
          }
          onClick={() => openInfoWindow(user)}
        >
          {/* {user.id == selectId && ( */}
          {open && (
            <InfoWindow
              position={{
                lat: user.latitude,
                lng: user.longitude,
              }}
              options={{
                pixelOffset: new window.google.maps.Size(0, -5),
                background: "blue",
              }}
              onLoad={onLoad}
              // onLoad={onLoad}
              onCloseClick={() => setOpen(false)}
              draggable={true}
            >
              <div
                className={`${
                  user.odStatus &&
                  user.odStatus === "OD_STARTED_AND_COMMUNICATION_SUBMITTED"
                    ? "success_color"
                    : user.odStatus === "OD_STARTED_BUT_NO_COMMUNICATION"
                    ? "od_started_but_no_communication"
                    : user.odStatus === "OD_COMPLETED_WITH_COMMUNICATION"
                    ? "od_completed_with_communication"
                    : user.odStatus === "OD_COMPLETED_WITHOUT_COMMUNICATION"
                    ? "od_completed_without_communication"
                    : user.odStatus === "OD_NOT_STARTED"
                    ? "od_not_started"
                    : ""
                } infhobox`}
              >
                <p className="userText">{`${user.name} ${
                  user.empCode ? `(${user.empCode})` : ""
                }`}</p>
                <p className="closeBtninfhowindow">
                  <CloseIcon
                    onClick={() => setOpen(false)}
                    sx={{ width: "13px" }}
                  />
                </p>
              </div>
            </InfoWindow>
          )}
          {/* )} */}
        </Marker>
        <OverlayView
          position={{
            lat: user.latitude,
            lng: user.longitude,
          }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          onLoad={onLoadInfo}
        >
          {/* <div
          style={{
            background: `var(--clr-black)`,
            color: `var(--clr-white)`,
            padding: `7px 12px`,
            fontSize: `11px`,
            borderRadius: `4px`,
          }}
        >
          {user.name}
        </div> */}
          <div></div>
        </OverlayView>
      </div>
    </>
  );
};

export default UserWithLabel;
